import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"min-width":"400px","width":"40vw","margin":"auto","margin-top":"40px"} }
const _hoisted_2 = { class: "fg-color-blue" }
const _hoisted_3 = {
  key: 0,
  class: "fg-color-gray"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["href"]
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "fg-color-gray" }
const _hoisted_8 = { class: "border-box" }

import { computed, watch, onMounted } from 'vue'
    import { useRouter } from 'vue-router'
    import { useCurrentUserQueryV1 } from '@Organizations/Users/queries-vue-composables'
    import { useResetPasswordCommandV1, useSignoutFromSessionCommandV1, useSignoutFromAllSessionsCommandV1 } from '@Organizations/Users/commands-vue-composables'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AccountPage',
  setup(__props) {

    const router = useRouter()
    const goBack = () => router.back()

    const {
        runCurrentUserQueryV1,
        modelCurrentUserQueryV1: userSessionDetails
    } = useCurrentUserQueryV1(false, false, false)

    const userId = computed(() => userSessionDetails.value?.UserId)
    const currentSessionId = computed(() => userSessionDetails.value?.CurrentSessionId)

    const { invokeResetPasswordCommandV1 } = useResetPasswordCommandV1(userId);
    const { invokeSignoutFromSessionCommandV1, onSucceedSignoutFromSessionCommandV1 } = useSignoutFromSessionCommandV1(userId, currentSessionId);
    const { invokeSignoutFromAllSessionsCommandV1, onSucceedSignoutFromAllSessionsCommandV1 } = useSignoutFromAllSessionsCommandV1(userId);


    onSucceedSignoutFromSessionCommandV1(() =>
    {
        location.href = '/#/signin'
    })

    onSucceedSignoutFromAllSessionsCommandV1(() =>
    {
        location.href = '/#/signin'
    })


    onMounted(() =>
    {
        document.title = 'TransparentChoice account'
        runCurrentUserQueryV1()
    })

    watch(userSessionDetails, (details) =>
    {
        if (!details) return

        if (details.UserId === 0)
        {
            router.push('/')
        }
    })

    function handleResetPassword()
    {
        if (confirm('Do you really want to reset your password?'))
        {
            invokeResetPasswordCommandV1()
        }
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      onClick: goBack,
      type: "button",
      class: "btn btn-lg btn-link"
    }, [...(_cache[2] || (_cache[2] = [
      _createElementVNode("i", {
        class: "fa fa-arrow-left",
        "aria-hidden": "true"
      }, null, -1 /* CACHED */),
      _createTextVNode(" Back ", -1 /* CACHED */)
    ]))]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(userSessionDetails)?.DisplayName), 1 /* TEXT */),
      _createElementVNode("div", null, [
        _cache[3] || (_cache[3] = _createElementVNode("span", null, "Organization: ", -1 /* CACHED */)),
        (_unref(userSessionDetails)?.OrganizationUnitId)
          ? (_openBlock(), _createElementBlock("strong", _hoisted_3, _toDisplayString(_unref(userSessionDetails)?.OrganizationUnitName), 1 /* TEXT */))
          : (_unref(userSessionDetails)?.IsGlobalAdmin)
            ? (_openBlock(), _createElementBlock("strong", _hoisted_4, [
                _createElementVNode("a", {
                  href: `/#/admin/organizations/users/manage/organization/${_unref(userSessionDetails).UserId}`
                }, "None", 8 /* PROPS */, _hoisted_5)
              ]))
            : (_openBlock(), _createElementBlock("strong", _hoisted_6, "None"))
      ]),
      _createElementVNode("div", null, [
        _cache[4] || (_cache[4] = _createElementVNode("span", null, "Email: ", -1 /* CACHED */)),
        _createElementVNode("strong", _hoisted_7, _toDisplayString(_unref(userSessionDetails)?.Email), 1 /* TEXT */)
      ]),
      _cache[10] || (_cache[10] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
      _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1 /* CACHED */)),
      _createElementVNode("div", { class: "border-box" }, [
        _cache[5] || (_cache[5] = _createElementVNode("h4", null, "My password", -1 /* CACHED */)),
        _cache[6] || (_cache[6] = _createElementVNode("p", { style: {"font-size":"16px"} }, "You can change password by providing your one or reset it to let us generate one for you and send it to your email", -1 /* CACHED */)),
        _cache[7] || (_cache[7] = _createElementVNode("a", {
          type: "button",
          class: "btn btn-primary mr-2",
          href: "/#/organizations/users/changepassword"
        }, "Change password", -1 /* CACHED */)),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary",
          onClick: handleResetPassword
        }, "Reset password")
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[8] || (_cache[8] = _createElementVNode("h4", null, "My sign-ins", -1 /* CACHED */)),
        _cache[9] || (_cache[9] = _createElementVNode("p", { style: {"font-size":"16px"} }, "Do you want do sign-out just from the current session or also from all other sessions on all other devices and browsers?", -1 /* CACHED */)),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary mr-2",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(invokeSignoutFromSessionCommandV1) && _unref(invokeSignoutFromSessionCommandV1)(...args)))
        }, "Current session"),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(invokeSignoutFromAllSessionsCommandV1) && _unref(invokeSignoutFromAllSessionsCommandV1)(...args)))
        }, "All my sessions")
      ]),
      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "border-box" }, [
        _createElementVNode("h4", null, "Access tokens"),
        _createElementVNode("p", { style: {"font-size":"16px"} }, "Manage your tokens for API calls"),
        _createElementVNode("a", {
          role: "button",
          class: "btn btn-primary",
          href: "/#/organizations/accesstokens/my"
        }, "My tokens")
      ], -1 /* CACHED */))
    ])
  ]))
}
}

})